import { render } from "./recposition.vue?vue&type=template&id=c4cf3b9c&scoped=true"
import script from "./recposition.vue?vue&type=script&lang=js"
export * from "./recposition.vue?vue&type=script&lang=js"

import "./recposition.vue?vue&type=style&index=0&id=c4cf3b9c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cf3b9c"]])

export default __exports__